module.exports = __webpack_public_path__ + "img/excel.6a223819.png";